// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1e0ca9',
        secondary: '#f3be02',
        success: '#1e0ca9',
        warning: '#ff9900',
        error: '#F11A16',
      },
      dark: {
        primary: '#1e0ca9',
        secondary: '#f3be02',
        success: '#1e0ca9',
        warning: '#ff9900',
        error: '#F11A16',
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg',
  },
});
